'use strict';

$(() => {
    var $topStrip = $('.experience-commerce_assets-shopNote');
    var $body = $('body');
    var $topStripCloseIcon = $topStrip.find('.icon-close');
    if (!sessionStorage.getItem('uniqueSession')) {
        sessionStorage.setItem('uniqueSession', Date.now());
        sessionStorage.setItem('shopNoteClosedAlready', 'false');
    }

    if (sessionStorage.getItem('shopNoteClosedAlready') === 'true') {
        $topStrip.addClass('hide-shop-note');
        $body.addClass('hide-shop-note');
        return;
    }
    $topStrip.removeClass('hide-shop-note').addClass('show-shop-note');
    $body.removeClass('hide-shop-note').addClass('show-shop-note');
    if ($('.experience-commerce_assets-shopNoteContent').length > 1) {
        const $shopComponentSlickRegion = $('.shop-note-component__content-region');
        const $shopNoteComponentContentWrapper = $('.shop-note-component__content-wrapper');
        const $animationStyle = $shopNoteComponentContentWrapper.data('animation');
        const $autoScrollSlides = $shopNoteComponentContentWrapper.data('auto-scroll');
        $shopComponentSlickRegion.find('.slick-prev').removeClass('d-none');
        $shopComponentSlickRegion.find('.slick-next').removeClass('d-none');
        const $slickObj = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1000,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        if ($animationStyle === 'fade-in') {
            $slickObj.fade = true;
            $slickObj.autoplay = true;
            $slickObj.autoplaySpeed = 3000;
            $slickObj.infinite = true;
            $slickObj.pauseOnHover = true;
            $slickObj.pauseOnFocus = true;
            $shopComponentSlickRegion.find('.slick-prev').addClass('d-none');
            $shopComponentSlickRegion.find('.slick-next').addClass('d-none');
        }

        if ($autoScrollSlides === true) {
            $slickObj.autoplay = true;
            $slickObj.autoplaySpeed = 3000;
            $slickObj.infinite = true;
            $slickObj.pauseOnHover = true;
            $slickObj.pauseOnFocus = true;
        }

        if (!$shopComponentSlickRegion.hasClass('slick-initialized')) {
            setTimeout(() => {
                $shopComponentSlickRegion.slick($slickObj);
            }, 100); // Delay to ensure it initializes properly
        }

        $shopComponentSlickRegion.on('click', '.slick-next', function () {
            $shopComponentSlickRegion.slick('slickNext');
        });
        $shopComponentSlickRegion.on('click', '.slick-prev', function () {
            $shopComponentSlickRegion.slick('slickPrev');
        });
    }

    $topStripCloseIcon.on('click', function () {
        $topStrip.addClass('hide-shop-note').removeClass('show-shop-note');
        $body.addClass('hide-shop-note').removeClass('show-shop-note');
        $body.css('--shop-note-height', '0px');
        $(document).trigger('shopnoteclose');
        sessionStorage.setItem('shopNoteClosedAlready', 'true');
    });
});
